


























































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IAccount } from "@/interfaces";
import { QrModal } from "@/components/modals";

@Component({
  components: {
    QrModal,
  },
  computed: {
    ...mapGetters("network", ["isListed", "knownAccounts", "token"]),
    ...mapGetters("currency", { currencyName: "name" }),
  },
})
export default class WalletDetails extends Vue {
  @Prop({ required: true }) public wallet: IAccount;

  private view = "public";
  private showModal = false;
  private knownAccounts: { [key: string]: string };
  private isListed: boolean;
  private token: string;
  private currencyName: string;

  get name() {
    return this.knownAccounts[this.wallet.name];
  }

  get isDelegate() {
    return this.wallet.isDelegate;
  }

  get votedDelegate() {
    return this.$store.getters["delegates/byPublicKey"](this.wallet.vote) || {};
  }

  get isVoting() {
    return !!this.wallet.vote;
  }

  get hasLockedBalance() {
    return !!this.wallet.lockedBalance;
  }

  get showBalanceTooltip() {
    return this.isListed && this.token !== this.currencyName;
  }

  private setView(view: string) {
    this.view = view;
  }

  private toggleModal() {
    this.showModal = !this.showModal;
  }
}
